// import mixpanel from 'mixpanel-browser';

export const initializeMixPanel = () => {
//  mixpanel.init(process.env.NEXT_PUBLIC_MIX_PANEL_TOKEN ?? "", {debug: process.env.NODE_ENV === 'development'});
}

export const trackEvent = (eventName:string, properties?:any)=> {
  // mixpanel.track(eventName, properties);
}

export const registerProperties = (properties:any)=> {
  // mixpanel.register(properties);
}


